import { render } from "./DateRangePicker.vue?vue&type=template&id=64f78942"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__